import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "../common/Reveal";
import "./Experience.css";
import "./Education.css";

export function Education() {
  const { t } = useLanguage();

  return (
    <section id="education" className="section education">
      <div className="container section-inner">
        <Reveal direction="up">
          <span className="eyebrow">{t.education.eyebrow}</span>
          <h2 className="section-heading">{t.education.heading}</h2>
        </Reveal>

        <div className="timeline timeline--static">
          <div className="timeline__track" />

          {t.education.items.map((edu, i) => (
            <Reveal direction="up" delay={0.05 * i} key={edu.id} className="timeline__item">
              <span className="timeline__dot" />
              <div className="timeline__card">
                <div className="timeline__card-head">
                  <div>
                    <h3 className="timeline__role">{edu.course}</h3>
                    <span className="timeline__org">{edu.institution}</span>
                  </div>
                  <span className="timeline__period mono">{edu.period}</span>
                </div>
                <p className="timeline__desc">{edu.description}</p>
              </div>
            </Reveal>
          ))}

          <Reveal direction="up" className="timeline__item timeline__item--placeholder">
            <span className="timeline__dot timeline__dot--muted" />
            <p className="timeline__placeholder-text">{t.education.placeholder}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
